import { DefaultService } from "../DefaultService";

export default class B2BLogisticaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(page = 0, limit = 20, ...params) {
        return this._http.get(encodeURI(`${this._env}/b2blogistica/findall.json?page=${page}&limit=${limit}&param=${params}`), this._headers)
        .then(res => {
            return res.body;
        },
        err => {
            this.handleError(err);
        });
    }
}